// extracted by mini-css-extract-plugin
export default {"ratingStars":"RatingStars-module__ratingStars___dy6XR","star":"RatingStars-module__star___Xkwc9","starWrapper":"RatingStars-module__starWrapper___NcNig"};